import React, { FunctionComponent, useContext } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { FormattedHTMLMessage } from "react-intl-phraseapp";
import { StatePicker, FocusableHeader } from "../../../components";
import SevenThingsDrawer from "../HelpDrawers/SevenThingsDrawer";
import { MedigapBenefitsHelpDrawer } from "../HelpDrawers/MedigapBenefitsHelpDrawer";
import { useTranslate, useQueryParams } from "../../../helpers";
import { Routes } from "../../../app";
import { County, ActionType } from "../../../@types";
import { AppContext } from "../../../app/store";
import {
  AnalyticsActionType,
  Ga4Event,
  Ga4EventType,
  MctPlanTypeStrings,
} from "../../../app/contexts/Analytics/types";
const MedigapLandingPage: FunctionComponent<RouteComponentProps> = ({
  history,
  location,
  match,
}) => {
  const t = useTranslate();
  const { dispatch, state } = useContext(AppContext);
  useQueryParams({ location, history, match });

  const onStateSelect = (county?: County, zipcode?: string): void => {
    if (county && zipcode) {
      if (county) {
        dispatch({ type: ActionType.UPDATE_COUNTY, payload: county });
        dispatch({ type: ActionType.UPDATE_FIPS, payload: county.fips });
      }

      if (zipcode) {
        dispatch({ type: ActionType.UPDATE_ZIPCODE, payload: zipcode });
      }

      history.push(Routes.medigap.plans);
    }
  };

  const searchButtonAnalytics = () => {
    dispatch({
      type: AnalyticsActionType.SEND_TEALIUM_EVENT,
      settings: {
        event_action: "Medigap - Find a Policy",
        event_label: "CTA: Start",
      },
    });
    dispatch({
      type: AnalyticsActionType.SEND_GA4_EVENT,
      settings: {
        event_name: Ga4Event.MEDIGAP_SEARCH,
        event_type: Ga4EventType.UI_INTERACTION,
        text: "start",
        mct_plan_type: MctPlanTypeStrings.MEDIGAP_PLAN,
        mct_medigap: true,
        mct_coverage_wizard: !!state.cwCoverage,
      },
    });
  };

  return (
    <div className="MedigapLandingPage">
      <div className="MedigapLandingPage__hero">
        <div className="MedigapLandingPage__heroContent">
          <FocusableHeader
            className="MedigapLandingPage__heroHeader"
            text={t("medigap.header")}
            ignoreFocus={false}
          />
          <div className="MedigapLandingPage__heroSubheader">
            <FormattedHTMLMessage id="medigap.subheader" tagName="span" />
          </div>
        </div>
      </div>

      <div className="MedigapLandingPage__content">
        <div className="MedigapLandingPage__card">
          <StatePicker
            className="MedigapLandingPage__statePicker"
            label={t("medigap.enter_your_zip")}
            onStateSelect={onStateSelect}
            onInputTealiumProps={{
              event_action: "Medigap - Find a Policy",
              event_label: "UI Form: Zip Code",
            }}
            onBtnClickAnalytics={searchButtonAnalytics}
            pickerIndex={0}
          />
        </div>

        <h2 className="MedigapLandingPage__content__heading ds-text-heading--xl">
          {t("medigap.how_to_buy")}
        </h2>
        <ul className="MedigapLandingPage__list">
          <li className="MedigapLandingPage__item">
            <div className="MedigapLandingPage__item__listNumber">
              {t("medigap.buy_policy_step1.list_number")}
            </div>
            <div className="MedigapLandingPage__item__itemContent">
              <h3 className="ds-text-heading--lg">
                {t("medigap.buy_policy_step1.title")}
              </h3>
              <span>{t("medigap.buy_policy_step1")}</span>
              <div className="MedigapLandingPage__link">
                <MedigapBenefitsHelpDrawer
                  onOpenTealiumProps={{
                    event_action: "Medigap - Find a Policy",
                    event_label: "Learn More: See benefits of each plan",
                  }}
                />
              </div>
            </div>
          </li>
          <li className="MedigapLandingPage__item">
            <div className="MedigapLandingPage__item__listNumber">
              {t("medigap.buy_policy_step2.list_number")}
            </div>
            <div className="MedigapLandingPage__item__itemContent">
              <h3 className="ds-text-heading--lg">
                {" "}
                {t("medigap.buy_policy_step2.title")}
              </h3>
              <span>{t("medigap.buy_policy_step2")}</span>
            </div>
          </li>
          <li className="MedigapLandingPage__item">
            <span className="MedigapLandingPage__item__listNumber">
              {t("medigap.buy_policy_step3.list_number")}
            </span>
            <div className="MedigapLandingPage__item__itemContent">
              <h3 className="ds-text-heading--lg">
                {t("medigap.buy_policy_step3.title")}
              </h3>
              <span>{t("medigap.buy_policy_step3")}</span>
            </div>
          </li>
        </ul>
        <div className="MedigapLandingPage__link">
          <SevenThingsDrawer />
        </div>
        <h2 className="ds-u-font-weight--bold">{t("medigap.bottom_header")}</h2>
        <div className="MedigapLandingPage__card">
          <StatePicker
            className="ds-u-margin-bottom--4 MedigapLandingPage__statePicker"
            label={t("medigap.enter_your_zip")}
            onStateSelect={onStateSelect}
            onInputTealiumProps={{
              event_action: "Medigap - Find a Policy",
              event_label: "UI Form: Zip Code",
            }}
            onBtnClickAnalytics={searchButtonAnalytics}
            pickerIndex={1}
          />
        </div>

        <div className="MedigapLandingPage__link">
          <Link
            to={Routes.questionRouting}
            className="mct-c-headerLogo"
            onClick={(): void => {
              dispatch({
                type: AnalyticsActionType.SEND_TEALIUM_EVENT,
                settings: {
                  event_action: "Medigap - Find a Policy",
                  event_label: "Looking for Medicare Advantage or drug plans",
                },
              });
            }}
            aria-label={t("medigap.looking_for_ma_or_pdp_plan_partd")}
          >
            {t("medigap.looking_for_ma_or_pdp_plan")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default withRouter(MedigapLandingPage);
